import "./Support.css"
import FormFillout from "./Form"

export default function SupportSection(){
return(
    <section className="SupportSection">
        <div className="Form">
            <h1>
                <u>
                    Support
                </u>
            </h1>
            <FormFillout/>
        </div>
    </section>
)
}